"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.rotationFromLeft = void 0;
var React = __importStar(require("react"));
var react_fontawesome_1 = require("@fortawesome/react-fontawesome");
function RotatableIcon(_a) {
    var animationSpeed = _a.animationSpeed, className = _a.className, icon = _a.icon, _b = _a.reverse, reverse = _b === void 0 ? false : _b, rotation = _a.rotation;
    return (React.createElement(react_fontawesome_1.FontAwesomeIcon, { icon: icon, flip: reverse ? 'vertical' : undefined, rotation: rotation, className: className, style: animationSpeed
            ? {
                transition: "transform ".concat(animationSpeed, "ms ease-in-out"),
            }
            : undefined }));
}
exports.default = RotatableIcon;
function rotationFromLeft(direction) {
    switch (direction) {
        case 'up':
            return 90;
        case 'right':
            return 180;
        case 'down':
            return 270;
    }
}
exports.rotationFromLeft = rotationFromLeft;
